<template>
	<Modal :title="$t('common.downloadCsvReport.modal.title')"
		   :close-on-click-outside="false"
		   @close="closeModal"
		   :width="800"
	>
		<template v-slot:body>
			<form class="base_margin modal-content flex flex_column">
				<div class="text_left">
					<md-radio v-model="form.fileType" :value="'xlsx'">
						{{ $t("common.format.xlsx") }}
					</md-radio>
					<md-radio v-model="form.fileType" :value="'csv'">
						{{ $t("common.format.csv") }}
					</md-radio>
				</div>
				<DatePicker
					v-on:input="changeDate"
					:value="form.dateRange"
					:placeholder="$t('common.assignmentDate')"
					type="daterange"
				></DatePicker>
				<div class="flex margin_top" @click="toggleCollapse">
					<span v-show="expanded" class="el-icon-arrow-up report-icon"/>
					<span v-show="!expanded" class="el-icon-arrow-down report-icon"/>
					<h5 class="font_bold">{{ $t("common.downloadCsvReport.modal.customize") }}</h5>
				</div>
				<DraggableFieldSelector v-show="expanded" style="margin-top: 3rem; margin-bottom: 2rem;"
										:title="$t('common.downloadCsvReport.modal.selection')"
										:options="reportFieldOptions"
										:selected-options="selectedReportFields"
										options-selected-field="selected"
										options-key-field="field"
										options-display-field="translation"
				/>
			</form>
			<div class="flex flex_between base_margin">
				<md-button class="md-blank" @click="closeModal">
					{{ $t("common.button.close") }}
				</md-button>
				<md-button class="opacity_5" :class="{ 'md-primary': submitBtnStatus }" @click="exportCsv">
					{{ $t("common.download") }}
				</md-button>
			</div>
		</template>
	</Modal>
</template>

<script>

import DatePicker from "@/components/templates/DatePicker";
import {allInvestmentsReceivablesApi} from "@/common/api/allInvestmentsReceivablesApi";
import Modal from "@/components/templates/modal/Modal";
import DraggableFieldSelector from "@/components/templates/common/DraggableFieldSelector";

export default {
	props: {
		accountId: { type: Number },
	},
	components: {
		DraggableFieldSelector,
		Modal,
		DatePicker
	},
	data() {
		return {
			form: {
				dateRange: ["", ""],
				fileType: "xlsx",
			},
			reportFieldOptions: [],
			selectedReportFields: [],
			expanded: false,
		};
	},
	computed: {
		submitBtnStatus() {
			return this.form.dateRange.every(value => value !== "");
		}
	},
	created() {
		this.getReportFields();
	},
	methods: {
		exportCsv() {
			if (!this.submitBtnStatus) {
				return;
			}

			const csvFields = []
			for (let i = 0; i < this.selectedReportFields.length; i++) {
				const entry = this.selectedReportFields[i];
				csvFields.push({ field: entry.field, position: i });
			}
			const params = {
				accountId: this.accountId,
				fromDate: this.form.dateRange[0],
				toDate: this.form.dateRange[1],
				fileType: this.form.fileType,
				fieldList: csvFields,
			};
			allInvestmentsReceivablesApi.inspection.exportCsv(params)
				.then(() => this.toastSuccess(this.$t("common.download.allDocuments.success.msg")))
				.catch(this.toast)
		},
		closeModal() {
			this.$emit("close");
		},
		changeDate(dateRange) {
			this.form.dateRange = dateRange;
		},
		toggleCollapse() {
			this.expanded = !this.expanded;
		},
		getReportFields() {
			allInvestmentsReceivablesApi.inspection.preferences()
				.then(res => {
					// all options
					this.reportFieldOptions = res.reportFields.map(field => {
						return {
							...field,
							selected: field.position >= 0
						};
					});

					// build selected list
					this.selectedReportFields = [];
					for (let field in this.reportFieldOptions) {
						if (this.reportFieldOptions[field].selected) {
							this.selectedReportFields.push({ ...this.reportFieldOptions[field] });
						}
					}
					this.selectedReportFields.sort(function(a, b) {
						return a.position - b.position;
					});

					this.form.fileType = res.fileType ?? "xlsx";
				});
		},
	}
};
</script>
<style>
.report-icon {
	margin-top: 5px;
	margin-right: 5px;
}
</style>
